import {Component, OnInit} from '@angular/core';
import {DipRegistrationContextService} from '../core/services/dip-registration-context.service';

@Component({
    selector: 'dip-registration-footer',
    templateUrl: './dip-registration-footer.component.html',
    styleUrls: ['./dip-registration-footer.component.scss'],
    standalone: false
})
export class DipRegistrationFooterComponent implements OnInit {

  phoneNumber: string;
  showCookieSettings: boolean;

  constructor( private dipRegistrationContextService: DipRegistrationContextService) {
  }
  ngOnInit() {
    this.phoneNumber = this.dipRegistrationContextService.getPhoneNumber();
    this.showCookieSettings = this.dipRegistrationContextService.getAppContext().context.metricsEnabled;
  }
}
